import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { delay } from '../../HOME/utils';
import { YELLOW, YOUTUBE } from '../../HOME/const';
import { YOUTUBE_TT } from '../const';
import { showHelp } from '../REDUX/actions';
import ContactButton from '../../HOME/COMPONENTS/ContactButton';

class Help extends Component {
  state = {};

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  dismiss = () => {
    this.setState({ closing: true });

    delay(() => {
      if (this.mounted) {
        this.setState({ closing: false }, () => this.props.showHelp(false));
      }
    });
  };

  render() {
    const cls = `tt-help ${this.state.closing ? 'fadeout' : 'fadein-fast'}`;
    const color = YELLOW;

    return (
      <div className={cls}>
        <Bullet row="1" />
        <span style={{ gridArea: '1/2', overflow: 'auto' }}>Tap to rotate tiles and align identically colored shapes.</span>
        <Bullet row="3" />
        <span style={{ gridArea: '3/2', overflow: 'auto' }}>
          The object of the game is to get all shapes properly aligned in as few rotations as possible.
        </span>
        <Bullet row="5" />
        <span style={{ gridArea: '5/2', overflow: 'auto' }}>
          Tap to the right of the tile's center to rotate clockwise and to the left - to rotate counter-clockwise.
        </span>
        <Bullet row="7" />
        <span style={{ gridArea: '7/2', overflow: 'auto' }}>
          Your <span style={{ color }}>grade</span> is based on your average score and the number of games played. Play{' '}
          <span style={{ color }}>ten times</span> or more to get full credit.
        </span>
        <div className="ms-start" style={{ gridArea: '9/1/auto/span 2', border: 'initial', margin: 0, color: 'orange' }} onClick={this.dismiss}>
          OK
        </div>
        <ContactButton size={36} service={YOUTUBE} url={YOUTUBE_TT} style={{ gridArea: '9/2', justifySelf: 'end' }} />
      </div>
    );
  }
}

function mapStateToProps({ tt, common }) {
  return { ...tt, ...common };
}

export default connect(
  mapStateToProps,
  { showHelp }
)(Help);

const Bullet = row => {
  const area = `${row.row}/1`;
  const color = YELLOW;
  return <span style={{ gridArea: area, marginRight: '10px', color }}>•</span>;
};
